const setBanner = (state, banner) => {
  state.banner = banner;
};

const setOffers = (state, offers) => {
  state.offers = offers;
};

const postOfferAction = (state, offers) => {
  state.postOfferAction = offers;
};

const getBanner = (state, bannerDetails) => {
  state.getBanner = bannerDetails;
};

const setTrackBannerByAction = (state, bannerDetails) => {
  state.setTrackBannerByAction = bannerDetails;
};

export default {
  setBanner,
  setOffers,
  postOfferAction,
  getBanner,
  setTrackBannerByAction,
};
